window.addEventListener('vueloaded', () => {
  const setupFileField = (field) => {
    let target;

    if(field.getAttribute('data-label-target')) {
      target = document.querySelector(field.getAttribute('data-label-target'));
    } else {
      target = field.parentNode.querySelector('.file-label');
    }

    field.addEventListener('change', event => {
      if(field.files.length > 0) {
        target.innerText = event.target.value.split('\\').pop();
      } else {
        target.innerText = '';
      }
    });
  };

  let fields = document.querySelectorAll('input[type="file"][data-file-input]');

  for(let i = 0; i < fields.length; i++) {
    setupFileField(fields[i]);
  }
});
